// Entry point for the shared pure-utility bundle loaded by public/index.html
// (and, over time, maison-liik-calculateur.html / calculateur-public.html)
// before the page's own script runs. Bundled to public/shared.js as an IIFE
// exposing `window.MLShared` — see package.json's "build" script.
//
// Phase 2 modularization.
//
// Slice 1 (utils/*): functions with zero dependency on the app's mutable
// ORDERS/PRODUCTS/SETTINGS globals — moving them cannot change runtime
// behavior. Each was verified byte-for-byte against the code it replaced.
//
// Slice 2 (services/pricing.js): order/item pricing math. These DID
// originally close over the mutable PRODUCTS/ORDERS globals; here they take
// `products`/`orders` as an explicit argument instead (real dependency
// injection, independently unit-tested — tests/unit/pricing.test.mjs).
// Exposed under the `pricing` namespace (not flattened via `export *`) so
// public/index.html's thin same-named wrappers (`function orderTotal(o){
// return pricing.orderTotal(PRODUCTS, o); }`) don't collide with anything.
// See REFACTOR_SECURITY_REPORT.md, Phase 2 section, for the full rationale
// and the before/after behavioral-equivalence checks run before each
// function was removed from the inline script.
export * from './utils/text.js';
export * from './utils/format.js';
export * from './utils/ids.js';
export * from './utils/phone.js';
export * from './utils/icons.js';
export * from './utils/geo.js';
// Slice 10 (app/permissions.js): the UI-only PERMISSIONS map + can() gate,
// moved verbatim. Flattened via `export *` (not namespaced) since nothing
// else in this bundle exports `can`/`PERMISSIONS` — see the module's own
// header comment for why this isn't the real security boundary.
export * from './app/permissions.js';
// Track 2 (app/validation.js, post-Phase-2 hardening — REFACTOR_SECURITY_REPORT.md
// §19): centralized form-validation rules. Flattened the same way as
// permissions.js — nothing else in this bundle exports any `validate*` name.
export * from './app/validation.js';
import * as pricing from './services/pricing.js';
import * as inventory from './services/inventory.js';
import * as wallet from './services/wallet.js';
import * as orders from './services/orders.js';
export { pricing, inventory, wallet, orders };
export { notifyStateChanged, subscribe as subscribeToState } from './app/store.js';
export * from './components/labels.js';
// Page-render functions, namespaced like the services above (their
// original names — viewDenied, viewDelivery, ... — are what
// public/index.html's thin wrappers are called, so they can't be
// flattened via `export *` without colliding).
import * as staticPages from './pages/static.js';
import * as deliveryPage from './pages/delivery.js';
import * as productsPage from './pages/products.js';
import * as dashboardPage from './pages/dashboard.js';
import * as ordersPage from './pages/orders.js';
import * as inventoryPage from './pages/inventory.js';
import * as walletPage from './pages/wallet.js';
import * as settingsPage from './pages/settings.js';
export const pages = { ...staticPages, ...deliveryPage, ...productsPage, ...dashboardPage, ...ordersPage, ...inventoryPage, ...walletPage, ...settingsPage };
